<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Button } from '@Shelly/shelly-design-system';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Components
	import CustomExpresion from '../AddonSettingsG2/AnalogInputSettings/CustomExpresion.svelte';
	//Types
	import type { Device } from '../../../types/Device';
	import type { CustomExpresionTypes, PeripheralSettings } from 'src/types/Peripherals';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { deepCopy } from 'src/helpers/utilities';

	export let device: Device, settings: any, settingType: CustomExpresionTypes;

	const component = 'input:2';
	let waitForResponse = false;
	let xSettings: PeripheralSettings = deepCopy(settings[component]);

	const save = async () => {
		waitForResponse = true;
		const res: SettingRequest = await gen2Request(device, 'Input.SetConfig', {
			id: 2,
			config: {
				[settingType]: {
					expr: xSettings[settingType].expr,
					unit: xSettings[settingType].unit,
				},
			},
		});
		if (res?.isok) {
			settings[component][settingType] = xSettings[settingType];
		}
		onSettingsResponse(res, device);
		waitForResponse = false;
	};
</script>

<CustomExpresion {device} type={settingType} bind:settings={xSettings} />

<Button size="m" width="full" loading={waitForResponse} class="text-uppercase" on:click={save}
	>{$format('button_save', { default: 'Save' })}</Button
>
